import React, { useState } from 'react'
import AuthLayout from 'layouts/AuthLayout'
import { useNavigate } from 'react-router-dom'
import 'styles/CardStyles.css' // Import shared styles
import logo from 'assets/greenamex-logo.png'

import { makeRequest } from 'services/request.service'
import { showAlert } from 'services/alerts.service'

const SignUpCard = () => {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [repeatEmail, setRepeatEmail] = useState('')
  const [password, setPassword] = useState('')
  const [repeatPassword, setRepeatPassword] = useState('')
  const [error, setError] = useState('')

  const [accessCode, setAccessCode] = useState('')
  const [unlocked, setUnlocked] = useState(false)
  const secret = 'letmein'
  const navigate = useNavigate()

  const validateForm = () => {
    if (!email) {
      setError('Email is required')
      return false
    }
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setError('Please enter a valid email address')
      return false
    }
    if (email !== repeatEmail) {
      setError('Email addresses do not match')
      return false
    }
    if (!password) {
      setError('Password is required')
      return false
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters long')
      return false
    }
    if (password !== repeatPassword) {
      setError('Passwords do not match')
      return false
    }
    setError('')
    return true
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (validateForm()) {
      showAlert({
        text: 'Signup success',
        icon: 'success'
      })
    }

    try {
      const result = await makeRequest({
        method: 'post',
        data: {
          firstName,
          lastName,
          email,
          password
        },
        url: '/signup',
        alertResult: true
      })
      if (result.status === 201) {
        navigate('/login')
      }
    } catch (error) {
      setError(error.message)
    }
  }

  if (!unlocked) {
    return (
      <div className='font-nunito min-h-screen flex items-center justify-center bg-greenPrimary'>
        <div className='bg-white p-8 rounded-xl shadow-md w-96 flex flex-col items-center'>
          <img src={logo} alt='App Logo' className='w-16 h-16 mb-2' />
          <h2 className='text-xl font-semibold text-greenPrimary mb-4'>Enter invite code</h2>
          <input
            type='password'
            value={accessCode}
            onChange={e => setAccessCode(e.target.value)}
            placeholder='Invite code'
            className='w-full px-4 py-2 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500'
          />
          <button
            onClick={() => {
              if (accessCode === secret) {
                setUnlocked(true)
              } else {
                showAlert({
                  text: 'Invalid code',
                  icon: 'error'
                })
              }
            }}
            className='w-full bg-greenPrimary text-white py-2 rounded-md hover:bg-green-900 transition'
          >
            Unlock
          </button>
        </div>
      </div>

    )
  }

  return (
    <AuthLayout>
      <h2 className='text-xl font-semibold text-greenPrimary mb-4'>Create Your Account</h2>

      <form onSubmit={handleSubmit} autoComplete='off' className='w-full'>
        {error && <p className='text-red-600 text-sm mb-4 text-center'>{error}</p>}

        <div className='mb-4'>
          <label className='block text-sm font-medium text-gray-600 mb-1'>First Name</label>
          <input
            type='text'
            name='firstName'
            value={firstName}
            onChange={e => setFirstName(e.target.value)}
            className='w-full px-3 py-2 border rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500'
          />
        </div>

        <div className='mb-4'>
          <label className='block text-sm font-medium text-gray-600 mb-1'>Last Name</label>
          <input
            type='text'
            name='lastName'
            value={lastName}
            onChange={e => setLastName(e.target.value)}
            className='w-full px-3 py-2 border rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500'
          />
        </div>

        <div className='mb-4'>
          <label className='block text-sm font-medium text-gray-600 mb-1'>Email Address</label>
          <input
            type='email'
            name='email'
            placeholder='you@example.com'
            value={email}
            onChange={e => setEmail(e.target.value)}
            className='w-full px-3 py-2 border rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500'
          />
        </div>

        <div className='mb-4'>
          <label className='block text-sm font-medium text-gray-600 mb-1'>Repeat Email Address</label>
          <input
            type='email'
            name='repeatEmail'
            placeholder='you@example.com'
            value={repeatEmail}
            onChange={e => setRepeatEmail(e.target.value)}
            className='w-full px-3 py-2 border rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500'
          />
        </div>

        <div className='mb-4'>
          <label className='block text-sm font-medium text-gray-600 mb-1'>Password</label>
          <input
            type='password'
            name='password'
            placeholder='********'
            value={password}
            onChange={e => setPassword(e.target.value)}
            className='w-full px-3 py-2 border rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500'
          />
        </div>

        <div className='mb-6'>
          <label className='block text-sm font-medium text-gray-600 mb-1'>Repeat Password</label>
          <input
            type='password'
            name='repeatPassword'
            placeholder='********'
            value={repeatPassword}
            onChange={e => setRepeatPassword(e.target.value)}
            className='w-full px-3 py-2 border rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500'
          />
        </div>

        <button
          type='submit'
          className='w-full bg-greenPrimary text-white py-2 rounded-md hover:bg-green-900 transition'
        >
          Sign Up
        </button>
      </form>

      <div className='mt-6 text-center text-sm text-gray-600'>
        Already have an account?{' '}
        <a
          href='#login'
          onClick={e => {
            e.preventDefault()
            navigate('/login')
          }}
          className='text-greenPrimary font-semibold hover:underline'
        >
          Log In
        </a>
      </div>
    </AuthLayout>
  )
}

export default SignUpCard
